import { render } from "./HomeMenu.vue?vue&type=template&id=3877a21e&ts=true"
import script from "./HomeMenu.vue?vue&type=script&lang=ts"
export * from "./HomeMenu.vue?vue&type=script&lang=ts"

import "./HomeMenu.vue?vue&type=style&index=0&id=3877a21e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__